export function getSourceAccountsV3(send) {
  return (query, ...args) =>
    send(
      {
        path: '/v3/sourceAccounts',
        pathParameters: {},
        type: 'get',
        query: query,
        body: undefined,
        headers: undefined,
        auth: 'oauth2',
        contentType: undefined,
      },
      ...args
    );
}
